import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import ListSidebar from './containers/ListSidebar';
import CreateSidebar from './containers/CreateSidebar';
import EditSidebar from './containers/EditSidebar';
import ViewSidebar from './containers/ViewSidebar';

const routes = [
    {
        type: 'crud',
        list: ListSidebar,
        create: CreateSidebar,
        edit: EditSidebar,
        view: ViewSidebar
    }
]

export default ModuleBootstrapper.getRoutes("sidebar", routes)
